export { CardContentTabs } from "./card-content-tabs";
export { KeyValueFields } from "./components";
export type { CollectionItem, FileItem } from "./components/index";
export type { TabConfiguration } from "./interface";
